import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { updateHubFilteredVessels, updatePermission } from "../../../actions/Users/authenticate";
import { useEffect, useState } from "react";
import { SIDE_MENU_ITEM_HUB } from "../../../utils/constants";
import { getDecodeURI, getEncodedURI, updateTimePeriod, checkLoggedInUserAuthorizedToViewPage } from "../../../utils/util";
import { getHubDataSitesList } from "../../../actions/Users/authenticateHub";
import _ from "lodash";
import TopologyAgentTable from "./TopologyAgentTable";
import ServiceTable from "./ServiceTable";
import CommonFilters from "../../../components/BreadCrumbs/CommonFilters";
import TabsComponent from "../../../components/NewTabs";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
import { GET_HUB_DASHBOARD_HUB_DATA, GET_HUB_DASHBOARD_CLIENT_WISE, GET_CARRIER_HUB_SDWAN_STATUS, GET_CARRIER_HUB_SDWAN_LATENCY, GET_CARRIER_HUB_SDWAN_DATA_RATES, GET_CARRIER_HUB_SDWAN_USAGE, GET_CARRIER_HUB_SDWAN_HUB_DROPDOWN } from "../../../actions/types";
import AgentSDWAN from './SDWAN';

const TopologyHubDetails = (props) => {
    const { match, authReducer, setTopologyHubTableLoading, setHubDashboardCarrierServiceTableLoading, updatePermission, getHubDataSitesList, location,  history, updateHubFilteredVessels,
        setCarrierHubSDWAnStatusLoading, setCarrierHubSDWAnLatencyLoading, setCarrierHubSDWANDataRatesLoading, setCarrierHubSDWANUsageLoading, setCarrierHubAgentDropdownLoading, setCarrierHubWanDropdownLoading, setCarrierHubSDWANHubsLoading, setCarrierHubListDropdownLoading,
        setCarrierHubSDWANBaseRttLoading, setCarrierHubSDWANCurrentRttLoading, setCarrierHubSDWANPacketDropLoading, setCarrierHubSDWANTunnelMigrationLoading, setCarrierHubSDWANPacingRateLoading, setCarrierHubSDWANBtlbwLoading, setCarrierHubSDWANBytesInFlightLoading, getCarrierHubSDWANCongestionWindowChart,
        setCarrierHubSDWANDroppedDataGramsLoading, setCarrierHubSDWANOneWayDelayOwdLoading, setCarrierHubSDWANAckCountLoading, setCarrierHubSDWANPacingLimitedLoading, setCarrierHubSDWANSentDataGramsLoading, setCarrierHubSDWANBlockCountLoading, setCarrierHubSDWANAgentsListLoading
     } = props;
    let _q: any = getDecodeURI(location.search);
    const [loading, setLoading] = useState('');

    const [activeTab, setActiveTab] = useState(match?.params?.tab ? match.params.tab.includes("?") ? match.params.tab.split("?")[0] : match.params.tab : "topology");
    const dispatch = useDispatch();

    if (authReducer && (!authReducer.sideMenu || SIDE_MENU_ITEM_HUB !== authReducer.sideMenu.menuItem)) {
        authReducer.sideMenu = { menuItem: SIDE_MENU_ITEM_HUB };
    }
    
    const VIEW_VESSEL_SUMMARY = "view-vessel-summary";
    const viewVesselSummaryService = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["service"];
    const viewVesselSummaryFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["function"];

    useEffect(() => {
        let authorized = checkLoggedInUserAuthorizedToViewPage(viewVesselSummaryService, viewVesselSummaryFunction);
        if (authorized && !authReducer.permission) {
            const info = {
                permission: {
                    service: viewVesselSummaryService,
                    serviceFunction: viewVesselSummaryFunction,
                },
                isMultiVessel: false,
                isSingleVessel: false,
                showOu: true,
                ou: authReducer.selectedOu ? authReducer.selectedOu : '',
                hubSites: false,
                isSingleAgent: true
            };
            updatePermission(info);
        }
    }, [activeTab])

    useEffect(() => {
        setLoading(setTopologyHubTableLoading || setHubDashboardCarrierServiceTableLoading || setCarrierHubSDWAnStatusLoading || setCarrierHubSDWAnLatencyLoading ||
            setCarrierHubSDWANDataRatesLoading || setCarrierHubAgentDropdownLoading || setCarrierHubWanDropdownLoading || setCarrierHubSDWANUsageLoading ||
            setCarrierHubSDWANHubsLoading || setCarrierHubListDropdownLoading || setCarrierHubSDWANBaseRttLoading || setCarrierHubSDWANCurrentRttLoading ||
            setCarrierHubSDWANPacketDropLoading || setCarrierHubSDWANTunnelMigrationLoading || setCarrierHubSDWANPacingRateLoading || setCarrierHubSDWANBtlbwLoading ||
            setCarrierHubSDWANBytesInFlightLoading || getCarrierHubSDWANCongestionWindowChart || setCarrierHubSDWANDroppedDataGramsLoading || setCarrierHubSDWANOneWayDelayOwdLoading||
            setCarrierHubSDWANAckCountLoading || setCarrierHubSDWANPacingLimitedLoading || setCarrierHubSDWANSentDataGramsLoading || setCarrierHubSDWANBlockCountLoading || setCarrierHubSDWANAgentsListLoading)
    }, [setTopologyHubTableLoading, setHubDashboardCarrierServiceTableLoading, setCarrierHubSDWAnStatusLoading, setCarrierHubSDWAnLatencyLoading,
        setCarrierHubSDWANDataRatesLoading, setCarrierHubAgentDropdownLoading, setCarrierHubWanDropdownLoading, setCarrierHubSDWANUsageLoading,
        setCarrierHubSDWANHubsLoading, setCarrierHubListDropdownLoading, setCarrierHubSDWANBaseRttLoading, setCarrierHubSDWANCurrentRttLoading,
        setCarrierHubSDWANPacketDropLoading, setCarrierHubSDWANTunnelMigrationLoading, setCarrierHubSDWANPacingRateLoading, setCarrierHubSDWANBtlbwLoading,
        setCarrierHubSDWANBytesInFlightLoading, getCarrierHubSDWANCongestionWindowChart, setCarrierHubSDWANDroppedDataGramsLoading, setCarrierHubSDWANOneWayDelayOwdLoading,
        setCarrierHubSDWANAckCountLoading, setCarrierHubSDWANPacingLimitedLoading, setCarrierHubSDWANSentDataGramsLoading, setCarrierHubSDWANBlockCountLoading, setCarrierHubSDWANAgentsListLoading])

    const doNavigateTab = (pathname, tabName) => {
        const currentParams = getDecodeURI(location?.search);
        const params:any = {};
        if (currentParams.ouName) {
          params['ouName'] = currentParams.ouName;
        }
        if (currentParams.ouId) {
          params['ouId'] = currentParams.ouId;
        }
        if (currentParams.k4Ids) {
          params['k4Ids'] = currentParams.k4Ids;
        }
        if (currentParams.agentK4Ids) {
          params['agentK4Ids'] = currentParams.agentK4Ids;
        }
        if(currentParams.sideNav){
          params['sideNav'] = currentParams.sideNav
        }
        if(currentParams.interval) {
          params['interval'] = currentParams.interval
        }
        if(currentParams.siteId) {
          params['siteId'] = currentParams.siteId
        }
        if(currentParams.agentId) {
          params['agentId'] = currentParams.agentId
        }
        if(currentParams.device_id) {
          params['device_id'] = currentParams.device_id
        }
        if(currentParams.interface_name) {
          params['interface_name'] = currentParams.interface_name
        }
        if(currentParams.wanId) {
          params['wanId'] = currentParams.wanId
        }
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        params.startDate = startDate;
        params.endDate = endDate;
        history.push({ pathname, search: getEncodedURI(params) });
        setActiveTab(tabName);
        dispatch({type: GET_CARRIER_HUB_SDWAN_HUB_DROPDOWN, payload: {}})
      }

    const tabs = [
        { tabName: 'Topology', tabValue: 'topology', pathName: '/fleet-dashboard/hub/topology' },
        { tabName: 'SDWAN', tabValue: 'sdwan', pathName: '/fleet-dashboard/hub/sdwan' }
    ]

    const gotoHubDashboard = () => {
        // Clear Redux state before navigating back
        dispatch({type: GET_HUB_DASHBOARD_HUB_DATA, payload: {}});
        dispatch({type: GET_HUB_DASHBOARD_CLIENT_WISE, payload: {}});
        dispatch({ type: GET_CARRIER_HUB_SDWAN_STATUS, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_LATENCY, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_DATA_RATES, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_USAGE, payload: {} });
        
        // Use browser history to go back to previous page
        history.goBack();
    }

    return (
        <div>
            <CommonFilters loading={loading} showWantType={false} showSummaryPeriod={true}></CommonFilters>
            <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} backButtonNeeded={true} goBack={gotoHubDashboard} />
            {activeTab == 'topology' ? <div className='hub-topology-parent-container'>
                <TopologyAgentTable />
                <ServiceTable />
            </div> : 
            activeTab == 'sdwan' ? <div className='hub-topology-parent-container'>
                <AgentSDWAN />
            </div>
            :
            null
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    setTopologyHubTableLoading: state.authReducer.setTopologyHubTableLoading,
    setHubDashboardCarrierServiceTableLoading: state.authReducer.setHubDashboardCarrierServiceTableLoading,
    setCarrierHubSDWAnStatusLoading: state.authReducer.setCarrierHubSDWAnStatusLoading,
    setCarrierHubSDWAnLatencyLoading: state.authReducer.setCarrierHubSDWAnLatencyLoading,
    setCarrierHubSDWANDataRatesLoading: state.authReducer.setCarrierHubSDWANDataRatesLoading,
    setCarrierHubSDWANUsageLoading: state.authReducer.setCarrierHubSDWANUsageLoading,
    setCarrierHubSDWANHubsLoading: state.authReducer.setCarrierHubSDWANHubsLoading,
    setCarrierHubAgentDropdownLoading: state.authReducer.setCarrierHubAgentDropdownLoading,
    setCarrierHubWanDropdownLoading: state.authReducer.setCarrierHubWanDropdownLoading,
    setCarrierHubListDropdownLoading: state.authReducer.setCarrierHubListDropdownLoading,
    setCarrierHubSDWANBaseRttLoading: state.authReducer.setCarrierHubSDWANBaseRttLoading,
    setCarrierHubSDWANCurrentRttLoading: state.authReducer.setCarrierHubSDWANCurrentRttLoading,
    setCarrierHubSDWANPacketDropLoading: state.authReducer.setCarrierHubSDWANPacketDropLoading,
    setCarrierHubSDWANTunnelMigrationLoading: state.authReducer.setCarrierHubSDWANTunnelMigrationLoading,
    setCarrierHubSDWANPacingRateLoading: state.authReducer.setCarrierHubSDWANPacingRateLoading,
    setCarrierHubSDWANBtlbwLoading: state.authReducer.setCarrierHubSDWANBtlbwLoading,
    setCarrierHubSDWANBytesInFlightLoading: state.authReducer.setCarrierHubSDWANBytesInFlightLoading,
    getCarrierHubSDWANCongestionWindowChart: state.authReducer.getCarrierHubSDWANCongestionWindowChart,
    setCarrierHubSDWANDroppedDataGramsLoading: state.authReducer.setCarrierHubSDWANDroppedDataGramsLoading,
    setCarrierHubSDWANOneWayDelayOwdLoading: state.authReducer.setCarrierHubSDWANOneWayDelayOwdLoading,
    setCarrierHubSDWANAckCountLoading: state.authReducer.setCarrierHubSDWANAckCountLoading,
    setCarrierHubSDWANPacingLimitedLoading: state.authReducer.setCarrierHubSDWANPacingLimitedLoading,
    setCarrierHubSDWANSentDataGramsLoading: state.authReducer.setCarrierHubSDWANSentDataGramsLoading,
    setCarrierHubSDWANBlockCountLoading: state.authReducer.setCarrierHubSDWANBlockCountLoading,
    setCarrierHubSDWANAgentsListLoading: state.authReducer.setCarrierHubSDWANAgentsListLoading,
});

export default withRouter(
    connect(mapStateToProps, {updatePermission, getHubDataSitesList, updateHubFilteredVessels})(TopologyHubDetails)
)